
import { useState, useEffect } from 'react';

interface DynamicStatusOptions {
  isActive: boolean;
  hasFile?: boolean;
  interval?: number; // ⚡ PADRÃO 500ms para máxima fluidez
}

export const useDynamicStatus = ({ isActive, hasFile = false, interval = 500 }: DynamicStatusOptions) => {
  const [currentStatusIndex, setCurrentStatusIndex] = useState(0);

  // ⚡ SUBSTITUÍDO: Apenas "Pensando..." para máxima simplicidade
  const generalStatuses = [
    "Pensando...",
    "Pensando...",
    "Pensando..."
  ];

  const fileStatuses = [
    "Pensando...",
    "Pensando...", 
    "Pensando..."
  ];

  const statuses = hasFile ? fileStatuses : generalStatuses;

  useEffect(() => {
    if (!isActive) {
      setCurrentStatusIndex(0);
      return;
    }

    // ⚡ INTERVALO ULTRA-RÁPIDO: 500ms para animação fluida
    const intervalId = setInterval(() => {
      setCurrentStatusIndex((prev) => (prev + 1) % statuses.length);
    }, interval);

    return () => clearInterval(intervalId);
  }, [isActive, statuses.length, interval]);

  return {
    currentStatus: statuses[currentStatusIndex],
    statusIndex: currentStatusIndex,
    totalStatuses: statuses.length
  };
};
